<template>
  <path
    d="M3.14645 0.646447C3.34171 0.451184 3.65829 0.451184 3.85355 0.646447L8.85355 5.64645C9.04882 5.84171 9.04882 6.15829 8.85355 6.35355L3.85355 11.3536C3.65829 11.5488 3.34171 11.5488 3.14645 11.3536C2.95118 11.1583 2.95118 10.8417 3.14645 10.6464L7.79289 6L3.14645 1.35355C2.95118 1.15829 2.95118 0.841709 3.14645 0.646447Z"
    fill="currentColor" />
</template>
